import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HostService } from 'services/host/host.service'

@Injectable({
	providedIn: 'root'
})
export class AuthService {

	constructor(public http: HttpClient, public hostService: HostService) { }

	host = this.hostService.host;

	token = 'token/';
	refresh = `${this.token}refresh/`;

	login(data: any): Promise<any> {
		return new Promise((resolve, reject) => {
			const httpOptions = {
				headers: new HttpHeaders({
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${localStorage.getItem('access')}`
				})
			};
			this.http.post(`${this.host}${this.token}`, data, httpOptions)
				.subscribe(
					data => {
						resolve(data);
					},
					error => {
						reject(error);
					}
				)
		})
	}

	updateToken(data: any): Promise<any> {
		return new Promise((resolve, reject) => {
			const httpOptions = {
				headers: new HttpHeaders({
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${localStorage.getItem('refresh')}`
				})
			};
			this.http.post(`${this.host}${this.refresh}`, data, httpOptions)
				.subscribe(
					data => {
						resolve(data);
					},
					error => {
						reject(error);
					}
				)
		})
	}


	consultarEstado(): Promise<any> {
		return new Promise((resolve, reject) => {
			this.http.get(`${this.host}consultar/acceso`)
				.subscribe(
					data => {
						resolve(data);
					},
					error => {
						reject(error)
					}
				)
		});
	}

}
